document.querySelectorAll('.swiper-mobile').forEach(function(element) {
  var spaceMobile = parseInt(element.dataset.spaceMobile, 10);
  var spaceDesktop = parseInt(element.dataset.spaceDesktop, 10);
  var swiperMobile = new Swiper(element, {
    slidesPerView: 1,
    spaceBetween: isNaN(spaceMobile) ? 10 : spaceMobile,
    loop:true,
    watchOverflow:true,
    navigation: {
      nextEl: element.querySelector('.swiper-button-next-mob'),
      prevEl: element.querySelector('.swiper-button-prev-mob'),
    },
    pagination: {
      el: element.querySelector('.swiper-pagination-mob'),
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: isNaN(spaceDesktop) ? 24 : spaceDesktop,
        loop: element.querySelectorAll('.swiper-slide').length > 4 ? true : false,

      }
    }
  });

});